<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on" elevation="0" class="mr-1" :small="$vuetify.breakpoint.mdAndDown">
        Minhas Reservas
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Minhas Reservas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false"> Fechar </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      
      <v-card class="ma-1" elevation="0" outlined>
          <v-card-title>
              <span class="mx-1">Minhas Reservas</span>
              <v-spacer></v-spacer>
              <v-btn @click.stop="loadMeusAgendamentos" :loading="computedIsLoading" color="primary" elevation="0" class="mx-1">
                <v-icon small class="mr-2">mdi-refresh</v-icon> Atualizar
              </v-btn>
              <v-text-field outlined dense v-model="search" append-icon="mdi-magnify" class="mx-1" label="Buscar" single-line hide-details clearable></v-text-field>
          </v-card-title>
          <v-card-text class="px-2">
            <v-data-table
              :headers="headers" 
              :items="$store.meusAgendamentosStore.state.agendas" 
              :search="search"
              :sort-by="['id']"
              :sort-desc="[true]"
              elevation="1" 
              no-data-text="Nenhuma reserva encontrada"
              no-results-text="Nenhuma reserva encontrada"
              loading-text="Carregando..."
              >
              <template v-slot:item.id="{ item }">
                <strong :class="getColor(item.status_agenda)" ># {{ item.id }}</strong>
              </template>
              <template v-slot:item.curso="{ item }">
                <strong :class="getColor(item.status_agenda)" >{{ item.curso }}</strong>
              </template>
              <template v-slot:item.disciplina="{ item }">
                <strong :class="getColor(item.status_agenda)" >
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text :class="getColor(item.status_agenda)" v-bind="attrs" v-on="on">
                        {{ item.disciplina|truncate(15) }}
                      </v-btn>
                    </template>
                    <span>{{item.disciplina}}</span>
                  </v-tooltip>
                </strong>
              </template>
              <template v-slot:item.status_agenda="{ item }">
                <strong :class="getColor(item.status_agenda)" >
                  {{ item.status_agenda }}
                  <v-tooltip left v-if="item.status_agenda=='NEGADO'">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn icon color="error" v-bind="attrs" v-on="on" @click="alertRessalva(item.status_ressalva)">
                              <v-icon >mdi-information</v-icon> 
                          </v-btn>
                      </template>
                      <div>
                          {{ item.status_ressalva }}
                      </div>
                  </v-tooltip>
                </strong>
              </template>
              <template v-slot:item.get_formatted_data="{ item }">
                <strong :class="getColor(item.status_agenda)" >{{ item.get_formatted_data }}</strong>
              </template>
              <template v-slot:item.horario="{ item }">
                <div style="inline-size: max-content;">
                    <v-tooltip right >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text color="#888" v-bind="attrs" v-on="on" small>
                                <v-icon>mdi-timer</v-icon> 
                            </v-btn>
                        </template>
                        <div>
                            {{ item.start }} às {{item.end}}
                        </div>
                    </v-tooltip>
                    <strong :class="getColor(item.status_agenda)" >
                        <!--{{item.horario}}-->
                        {{ item.start }} às {{item.end}}
                    </strong>
                        
                </div>
              </template>
              <template v-slot:item.get_sala.sala="{ item }">
                <v-tooltip right v-if="item.get_sala.contexto">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn text color="#888" v-bind="attrs" v-on="on" small>
                              <v-icon>mdi-office-building-marker-outline</v-icon> ({{item.get_sala.get_contexto.descricao.split('')[0]}}{{item.get_sala.get_contexto.descricao.split('')[1]}})
                          </v-btn>
                      </template>
                      <div>
                          {{ item.get_sala.get_contexto.descricao}} 
                      </div>
                  </v-tooltip>
                <strong :class="getColor(item.status_agenda)" >{{ item.get_sala.sala }}</strong>

              </template>
              <template v-slot:item.get_finalidade.descricao="{ item }">
                <strong :class="getColor(item.status_agenda)" >{{ item.get_finalidade.descricao }}</strong>
              </template>
            </v-data-table>
          </v-card-text>
      </v-card>
      
      
    </v-card>
  </v-dialog>
</template>

<script>
import AuthService from '@/services/authService'
import USUARIO_LOGADO from '@/services/authService'

  export default {
    name: 'MeusAgendamentos',
    data () {
      return {
        search:'',
        dialog: false,
        headers: [
          { text: 'ID', align: 'start', sortable: true, value: 'id', },
          { text: 'Curso', align: 'start', sortable: true, value: 'curso', },
          { text: 'Disciplina', align: 'start', sortable: true, value: 'disciplina', },
          { text: 'Sala', align: 'start', sortable: true, value: 'get_sala.sala', },
          { text: 'Data', value: 'get_formatted_data', sortable: true },
          { text: 'Horario', value: 'horario', sortable: false },
          //{ text: 'Finalidade', value: 'get_finalidade.descricao', sortable: true },
          { text: 'Status', value: 'status_agenda', sortable: true },
        ],
        
      }
    },
    methods: {
      alertRessalva(value){
        alert(value)
      },
      getColor (status) {
        let cor = ''
        switch(status){
          case 'PENDENTE': cor = 'warning--text'; break;
          case 'NEGADO': cor = 'error--text'; break;
          case 'APROVADO': cor = 'success--text'; break;
          default: cor = 'black--text';
        }
        return cor
      },
      loadMeusAgendamentos(){
        let params = ''
        let isAuth = AuthService.isAuthenticated()
        let userAuth = AuthService.obterUsuarioAutenticado(USUARIO_LOGADO)
        if(isAuth && (userAuth && userAuth.username)){
            params = '?created_by='+userAuth.username
        }
        this.$store.meusAgendamentosStore.dispatch('get_minhas_agendas',params)
      }
    },
    computed:{
      computedIsLoading(){
        return this.$store.meusAgendamentosStore.getters.isLoading
      }
    },
    mounted(){
      this.loadMeusAgendamentos()

		setInterval( ()=>{ this.loadMeusAgendamentos() }, 60000)
    }
  }
    
</script>